import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';

const StepProgress = () => {
  const [gridData, setGridData] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const { branchId } = useParams();

  const steps = [
    {
      title: 'تنظیمات پایه شعبه',
      content:
        <div>
          <p>به نرم‌افزار مدیریت رستوران‌ها خوش آمدید! برای شروع، به قسمت تنظیمات پایه مراجعه کرده و دکمه "بازنشانی تنظیمات اولیه" را فشار دهید تا تمامی تنظیمات به حالت پیش‌فرض بازگردند.</p>
          <Link className='btn btn-sm btn-outline-purple' to={`/sale/${branchId}/branchSetting`}>تنظیمات پایه شعبه</Link>
        </div>,
    },
    {
      title: 'اطلاعات عمومی',
      content:
        <div>
          <p>در این مرحله، به داشبورد «اطلاعات عمومی» بروید و موارد مورد نیاز شامل طبقات کالا، واحدهای سنجش و کالاها را به ترتیب کامل کنید. </p>
          <Link className='btn btn-sm btn-outline-purple' to={`/baseinfo/${branchId}`}>اطلاعات عمومی</Link>
        </div>
    },
    {
      title: 'تعریف خدمات',
      content:
        <div>
          <p>در این مرحله، "خدمات" مختلفی که در فاکتورها نمایش داده می‌شوند را تعریف کنید، از جمله هزینه ارسال، هزینه بسته‌بندی و حق سرویس. این هزینه‌ها باید به‌گونه‌ای تنظیم شوند که منعکس‌کننده خدمات ارائه شده به مشتریان باشند.</p>
          <Link className='btn btn-sm btn-outline-purple' to={`/sale/${branchId}/serviceSetting`}>تعریف خدمات</Link>
        </div>
    },
    {
      title: 'تنظیمات ارسال',
      content:
        <div>
          <p>در این مرحله به "تنظیمات ارسال" مراجعه کنید. مناطقی که خدمات ارسال به آن‌ها ارائه می‌دهید را مشخص کنید و برای هر محله، نام و هزینه ارسال را تعیین کنید. این قیمت‌ها باید به ریال وارد شوند و به راحتی توسط مشتریان قابل مشاهده باشند.</p>
          <Link className='btn btn-sm btn-outline-purple' to={`/sale/${branchId}/shipmentManger`}>تنظیمات ارسال</Link>
        </div>
    },
    {
      title: 'بخش‌های فروش',
      content:
        <div>
          <p>در این مرحله اطلاعات مربوط به بخش‌های فروش شعبه خود را کامل کنید. با افزودن بخش‌های مختلف، می‌توانید مدیریت بهتری بر روی فروش و محصولات خود داشته باشید و تجربه مشتریان را بهبود بخشید.</p>
          <Link className='btn btn-sm btn-outline-purple' to={`/sale/${branchId}/saleunits`}>بخش‌های فروش</Link>
        </div>
    },
    {
      title: 'تعریف منو',
      content:
        <div>
          <p>در این بخش، منوهای فروش خود را تنظیم کنید. می‌توانید زیردسته‌ها و منوهای ویژه‌ای را برای هر دسته‌بندی اضافه کنید.</p>
          <Link className='btn btn-sm btn-outline-purple' to={`/sale/${branchId}/selectUnit`}>تعریف منو</Link>
        </div>,
    },
    {
      title: 'کارمندان',
      content:
        <div>
          <p>به قسمت "مدیریت کارمندان"بروید و کارمندان شعبه خود را تعریف کنید. با استفاده از دکمه "مدیریت نقش‌ها" می‌توانید نقش‌های مختلفی را به کارمندان تخصیص دهید.</p>
          <Link className='btn btn-sm btn-outline-purple' to={`/sale/${branchId}/employee`}>کارمندان</Link>
        </div>
    },
    {
      title: 'پوز',
      content:
        <div>
          <p>  به بخش "دستگاه و صندوق" بروید و موارد مربوط به تعریف  پوز (پایانه فروش) و سایر نیازمندی‌ها را تنظیم کنید.</p>
          <Link className='btn btn-sm btn-outline-purple' to={`/sale/${branchId}/posDevices`}>پوز</Link>
        </div>,
    },
    {
      title: 'پرینتر',
      content:
        <div>
          <p>تنظیمات مربوط به پرینترها را انجام دهید. اطمینان حاصل کنید که پرینترهای شما به‌درستی به سیستم متصل شده و آماده چاپ فاکتورها و گزارش‌ها هستند. هر پرینتر باید وابسته به یک بخش خاص از فروش باشد.</p>
          <Link className='btn btn-sm btn-outline-purple' to={`/sale/${branchId}/printer`}>پرینتر</Link>
        </div>
    },
    {
      title: 'صندوق',
      content:
        <div>
          <p>صندوق‌های فروش خود را مدیریت کنید. با استفاده از دکمه "بستن صندوق"، می‌توانید صندوق‌های خود را فعال یا غیر فعال کنید و گزارش‌های مالی مربوط به هر یک را مشاهده نمایید. این اطلاعات برای بررسی فعالیت‌های مالی روزانه شما بسیار مهم هستند.</p>
          <Link className='btn btn-sm btn-outline-purple' to={`/sale/${branchId}/cashDeskManage`}>صندوق</Link>
        </div>
    },
  ];
  
  const getGridData = async () => {
    const resp = await apiMethod.getBranchStatus(branchId);
    if (methods.showApiErrors(resp)) {
      setGridData(resp.data);

      const firstIncompleteIndex = resp.data.findIndex(step => !step.isComplete);
      if (currentStep === 0) {
        setCurrentStep(firstIncompleteIndex !== -1 ? firstIncompleteIndex : 0);
      }
    }
  };

  useEffect(() => {
    getGridData();
  }, [branchId]);
  // Check if all steps are complete
  const allStepsComplete = gridData.every(step => step.isComplete);
  if (allStepsComplete) {
    return null;
  }
  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setGridData(prevGridData => {
        const updatedData = [...prevGridData];
        if (updatedData[currentStep]) {
          updatedData[currentStep].isComplete = true;
        }
        return updatedData;
      });
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep((prevStep) => prevStep - 1);
    }
  };


  return (
    <div className="mx-auto mb-3">
      <div className="text-center shadow-lg px-3 rounded-4 py-2 border border-1 bg-white border-2">
        <div className='d-flex justify-content-center align-items-center'>
          <p>{gridData[currentStep]?.isComplete ? <i className="bi bi-check-circle-fill text-success fs-3 me-1"></i> : ""}</p>
          <p className='step-title'>
            {currentStep + 1}-{steps[currentStep].title}
          </p>
        </div>
        <div className='step-content'>{steps[currentStep].content}</div>
        <div className="d-flex justify-content-evenly align-items-baseline my-3">
          {currentStep > 0 && (
            <Link onClick={prevStep} className="btn btn-sm btn-secondary">
              قبلی
            </Link>
          )}
          {currentStep < steps.length - 1 && (
            <Link onClick={nextStep} className="btn btn-sm btn-purple">
              بعدی
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default StepProgress;